/**
 * Placeholder format rule for manually entered serial numbers:
 * 6 to 20 characters, letters, digits, and dashes.
 * Applied before the inventory check.
 */
export const SERIAL_NUMBER_PATTERN = /^[A-Za-z0-9-]{6,20}$/;

export const SERIAL_NUMBER_FORMAT_ERROR = "Serial numbers are 6 to 20 characters, letters and numbers only.";

export const isValidSerialNumberFormat = (serial: string): boolean =>
  SERIAL_NUMBER_PATTERN.test(serial.trim());

/** Returns an error message for a non-empty, badly formatted serial; otherwise an empty string. */
export const getSerialNumberFormatError = (serial?: string): string => {
  const trimmed = (serial ?? "").trim();
  if (!trimmed) return "";
  return isValidSerialNumberFormat(trimmed) ? "" : SERIAL_NUMBER_FORMAT_ERROR;
};
